import React from "react"
import useStyles from "./styles"
import { Box, CircularProgress, Typography, Switch } from "@material-ui/core"
import PropTypes from "prop-types"

const TitleSubtitleSwitch = ({
  titleText,
  subtitleText,
  stateVar = false,
  setterFn = () => {},
  loading = false,
  disabled = false,
}) => {
  const classes = useStyles()
  return (
    <Box display="flex" flexDirection="column">
      <Typography variant="h3" className={classes.headerText}>
        {titleText}
      </Typography>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography variant="subtitle1" className={classes.subtitleText}>
          {subtitleText}
        </Typography>
        {loading ? (
          <Box mr={2}>
            <CircularProgress size={25} />
          </Box>
        ) : (
          <Switch
            checked={Boolean(stateVar)}
            onChange={setterFn}
            disabled={disabled}
            inputProps={{ "aria-label": "deposit-required-switch" }}
          />
        )}
      </Box>
    </Box>
  )
}

TitleSubtitleSwitch.propTypes = {
  titleText: PropTypes.string,
  subtitleText: PropTypes.string,
  stateVar: PropTypes.bool,
  setterFn: PropTypes.func,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
}
export default TitleSubtitleSwitch
